/**
 * OrderStatusBadge — render an order status as a toned pill (wash + border + text).
 *
 * Maps the FSM status to a design tone (approved DESIGN/ mockups):
 *   created / awaiting_seller / awaiting_payment / paid → gold (ожидание)
 *   accepted / payment_check / in_progress            → info (в работе)
 *   completed                                         → success (выполнен)
 *   cancelled / refund                                → danger (отменён)
 *   disputed                                          → glitter (спор)
 *
 * The Russian label is sourced from {@link ORDER_STATUS_PRESENTATION}.
 */
import { ORDER_STATUS_PRESENTATION, type OrderStatus } from "../model";
import styles from "./OrderStatusBadge.module.css";

export interface OrderStatusBadgeProps {
  readonly status: OrderStatus;
}

type StatusTone = "gold" | "info" | "success" | "danger" | "glitter";

const STATUS_TONE: Readonly<Record<OrderStatus, StatusTone>> = {
  created: "gold",
  awaiting_seller: "gold",
  awaiting_payment: "gold",
  payment_declared: "gold",
  paid: "gold",
  accepted: "info",
  payment_check: "info",
  in_progress: "info",
  completed: "success",
  cancelled: "danger",
  refund: "danger",
  disputed: "glitter",
};

export function OrderStatusBadge({
  status,
}: OrderStatusBadgeProps): JSX.Element {
  const { label } = ORDER_STATUS_PRESENTATION[status];
  const tone = STATUS_TONE[status];
  return (
    <span className={`${styles.pill} ${styles[tone]}`}>{label}</span>
  );
}
